// PendingApproval — full-screen state for a signed-in account that an admin
// has not approved yet.
//
// New signups land in user_roles.status = 'pending' (see
// backend/middleware/auth.js), which 403s every API call with code
// ACCOUNT_PENDING. Without this screen the app looks broken rather than
// gated: a signed-in shell where every panel silently fails to load.
//
// Rendered as an overlay from App on the `tekstak:account-pending` event, so
// it works identically on web and in the native shell (which cannot hard
// navigate to a route path — there is no server behind capacitor://localhost).
import React from 'react';
import { Clock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

export default function PendingApproval() {
  const { user, signOut } = useAuth();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="email-verify-icon">
          <Clock size={32} aria-hidden="true" />
        </div>

        <div className="login-header">
          <h1 className="login-title">Awaiting approval</h1>
          <p className="login-subtitle">Your account has been created</p>
        </div>

        <div className="email-verify-instructions">
          <p>
            {user?.email ? <strong>{user.email}</strong> : 'Your account'} is
            waiting for an administrator to grant access. You'll be able to sign
            in normally once it's approved.
          </p>
        </div>

        <div className="email-verify-actions">
          <button
            type="button"
            className="login-button"
            onClick={() => window.location.reload()}
          >
            Check again
          </button>
          <button
            type="button"
            className="login-button oauth-button"
            onClick={signOut}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
